<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'waters.pricing.card-title' | translate }}</mat-card-title>
    <mat-card-subtitle>{{ 'waters.pricing.card-hint' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content class="!pt-4">
    @if (showNoSeasonsWarning()) {
      <div class="mb-4 border-l-4 border-amber-500 bg-amber-50 rounded p-3 flex items-start gap-3 dark:border-amber-400 dark:bg-amber-950/40">
        <mat-icon class="!text-amber-500 dark:!text-amber-400">warning</mat-icon>
        <p class="text-sm">{{ 'waters.pricing.no-seasons-warning' | translate }}</p>
      </div>
    }
    @if (showNoStayTypesWarning()) {
      <!-- The stay types are the lake's week/midweek/weekend flags on the General tab, not periods —
           but they block every grid just as completely, so the tab has to say so here too. -->
      <div class="mb-4 border-l-4 border-amber-500 bg-amber-50 rounded p-3 flex items-start gap-3 dark:border-amber-400 dark:bg-amber-950/40">
        <mat-icon class="!text-amber-500 dark:!text-amber-400">warning</mat-icon>
        <p class="text-sm">{{ 'waters.pricing.no-stay-types-warning' | translate }}</p>
      </div>
    }

    <button mat-flat-button color="primary" [routerLink]="['/waters/edit', waterId(), 'pricing']">
      <mat-icon>edit</mat-icon>
      {{ 'waters.pricing.edit' | translate }}
    </button>
  </mat-card-content>
</mat-card>
